import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_NGM_CUSTOMER_DATA,
  API_COMPLETE_GET_NGM_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA,
  API_INITIATE_GET_NGM_DOWNLOAD_CSV_FILE,
  API_COMPLETE_GET_NGM_DOWNLOAD_CSV_FILE,
} from '../../app-constants';
import View from './ngm-homepage.presenter';
import { submitNGMCustomerData, submitNGMRecommendPlanData, downloadCSVFile } from './ngm-homepage.actions';
// Reducer
export const ngmHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerAccountNumber: '',
  customerAbn: '',
  getData: '',
  referenceNumber: '',
  excelFileDownloadInProgress: false,
  alreadySubmitted: false,
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_NGM_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true, referenceNumber: action.data.referenceNumber };
    case API_COMPLETE_GET_NGM_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerAccountNumber: action.data.accountNumber,
        customerAbn: action.data.abn,
        getData: action.data,
        alreadySubmitted: action.data.alreadySubmitted,
      };
    }
    case API_INITIATE_GET_NGM_DOWNLOAD_CSV_FILE:
      return { ...state, excelFileDownloadInProgress: true };
    case API_COMPLETE_GET_NGM_DOWNLOAD_CSV_FILE:
      return { ...state, excelFileDownloadInProgress: false };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.ngmHomePageReducer.customerAccountNumber,
  customerAccountName: state.ngmHomePageReducer.customerAccountName,
  customerAbn: state.ngmHomePageReducer.customerAbn,
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.ngmHomePageReducer.dataLoaded,
  getData: state.ngmHomePageReducer.getData,
  formSubmitted: state.ngmHomePageReducer.formSubmitted,
  referenceNumber: state.ngmHomePageReducer.referenceNumber,
  excelFileDownloadInProgress: state.ngmHomePageReducer.excelFileDownloadInProgress,
  alreadySubmitted: state.ngmHomePageReducer.alreadySubmitted,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitNGMCustomerData,
    submitNGMRecommendPlanData,
    downloadCSVFile,
  }, dispatch),
});

const NGMHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default NGMHomePage;
